module.exports = {
      id: "icon-whatsapp-usage",
      viewBox: "0 0 25.91 25.969",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-whatsapp",
      toString: function () {
        return this.url;
      }
    }